module.exports = __webpack_public_path__ + "img/campus_recruitment.1a7560d.webp";